// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#Infographic figure[data-v-517faacb]{margin:0}#Infographic img[data-v-517faacb]{max-width:100%;width:100%;margin:auto}", ""]);
// Exports
module.exports = exports;
